"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserName = exports.CSS = void 0;
const mithril_1 = require("../../mithril");
const index_1 = require("../../store/index");
const userDisplayName_1 = require("../../util/userDisplayName");
exports.CSS = {
    container: 'c-UserName',
};
exports.UserName = {
    view(userId) {
        if (userId == null) {
            return null;
        }
        const user = index_1.AppStore.UserProfile.get(userId);
        if (user == null) {
            return null;
        }
        return (0, mithril_1.m)('span', { className: exports.CSS.container }, (0, userDisplayName_1.userDisplayName)(user));
    },
};
//# sourceMappingURL=username.js.map